import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as fnbActions from './../../../../../../actions/fnbAction';
import OutletList from './OutletList';

const mapStateToProps = state => {
    return {
        fnbState: state.fnbReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOutlets: (filters) => dispatch(fnbActions.getOutlets(filters)),
        syncOutlets: () => dispatch(fnbActions.syncOutlets()),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OutletList));
